export default "__VITE_ASSET__B4xnHu$b__"